const TAB_KEY = 'basicInfo'
export default {
  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/tracker.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'base',
            route: 'tracker'
          }
        },
        afterSave: () => this.afterSave(),
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.basic_info'),
            showBackButton: {
              onGoBack: () => this.backToMainTable()
            },
            onCancelTabSave: (event) => this.backToMainTable(event)
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'model_id',
                    label: this.$t('base/tracker.model'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'tracker-model/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'sim_id',
                    label: this.$t('base/sim.sim'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'sim/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'serial',
                    label: this.$t('base/tracker.serial'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'imei',
                    label: this.$t('base/tracker.imei'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_method',
                    label: this.$t('base/tracker.installation_method'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'comment',
                    label: this.$t('base/tracker.comment'),
                    type: 'textarea',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    backToMainTable () {
      this.createMode = false
    },

    afterSave () {
      this.createMode = false
    }
  }
}
